module.exports = __webpack_public_path__ + "static/Sign Card-77ff2f47b6ff3ea351000fa52f75e975.png";